import React from "react";
import { Link } from "react-router-dom";
import "./ContactCTA.css";
import forward from '../../Assets/next-arrow.png';

function ContactCTA() {
  return (
    <section className="contact-cta" id="contact">
      <div className="contact-cta-glow" />

      <div className="contact-cta-container">


        <div className="contact-cta-content">
          <span className="contact-cta-eyebrow">
            End-to-End Production
          </span>

          <h2 className="contact-cta-heading">
            LET'S CREATE
            <span>SOMETHING</span>
            <strong>UNFORGETTABLE</strong>
          </h2>

          <p className="contact-cta-description">
            Have an idea? Let's work together to create stunning visuals,
            powerful brands, modern websites, and marketing strategies that help your business grow
          </p>

          <Link to="/contact" className="contact-cta-button">
            <span className="contact-cta-button-text">
              Start A Project
            </span>

            <span className="contact-cta-button-circle">
             <img src={forward} alt="arrow" className="cta-arrow" />
            </span>
          </Link>
        </div>


      </div>

    </section>
  );
}

export default ContactCTA;